<template>
	<span class="uv-tile-flag-toyotacertified"
	>Toyota Certified</span>
</template>
<script setup lang="ts">

</script>